import React from "react";

function AccessoriesForm({ additionalAttributes, setAdditionalAttributes }) {
  const handleChange = (e) => {
    setAdditionalAttributes({
      ...additionalAttributes,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="accessoriesForm">
      {/* Kateqoriya */}
      <div>
        <h3>Kateqoriya <span>*</span></h3>
        <select name="category" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Kişi">Kişi</option>
          <option value="Qadın">Qadın</option>
          <option value="Uşaq">Uşaq</option>
        </select>
      </div>

      {/* Aksessuar növü */}
      <div>
        <h3>Aksessuar növü <span>*</span></h3>
        <select name="type" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Saat">Saat</option>
          <option value="Çanta">Çanta</option>
          <option value="Gözlük">Gözlük</option>
          <option value="Kəmər">Kəmər</option>
          <option value="Bijuteriya">Bijuteriya</option>
          <option value="Şərf və Papaq">Şərf və Papaq</option>
        </select>
      </div>

      {/* Material növü */}
      <div>
        <h3>Material <span>*</span></h3>
        <select name="material" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Dəri">Dəri</option>
          <option value="Metal">Metal</option>
          <option value="Plastik">Plastik</option>
          <option value="Taxta">Taxta</option>
          <option value="Pambıq">Pambıq</option>
        </select>
      </div>

      {/* Rəng */}
      <div>
        <h3>Rəng <span>*</span></h3>
        <input type="text" name="color" required placeholder="Rəngi daxil edin" onChange={handleChange} />
      </div>

      {/* Brend */}
      <div>
        <h3>Marka <span>*</span></h3>
        <input type="text" name="brand" required placeholder="Marka adını daxil edin" onChange={handleChange} />
      </div>

      {/* Yeni və ya istifadə olunmuş */}
      <div>
        <h3>İstifadə vəziyyəti <span>*</span></h3>
        <select name="condition" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Yeni">Yeni</option>
          <option value="İkinci əl">İkinci əl</option>
        </select>
      </div>

    </div>
  );
}

export default AccessoriesForm;
